import { Calculation } from "@/components/CustomCalculations/models/Calculation";
import { CalculationsJsonParsingInputType } from "@/components/CustomCalculations/services/CalculationsJsonParsingService";
import { IQueueExecutionCustomCalculationsProp } from "@/shared/Executions/models/IQueueExecutionRequest";
import { CdnSchemaJsonParsingResult } from "../models/CdnSchemaJsonParsingResult";
import { SchemaCoalesceService } from "./SchemaCoalesceService";


export class CalculationsSchemaCoalesceService extends SchemaCoalesceService<Calculation, CalculationsJsonParsingInputType, IQueueExecutionCustomCalculationsProp> {

    public coalesceParsingResultparsingResult(parsingResult: CdnSchemaJsonParsingResult<Calculation, CalculationsJsonParsingInputType>): IQueueExecutionCustomCalculationsProp {
        if (parsingResult == null) throw Error("parsingResult is required");
        if (!parsingResult.valid) throw Error("valid parsingResult required");

        const coalesceResult: IQueueExecutionCustomCalculationsProp = {
            calculations: parsingResult.parsedEntities ?? [],
            output: {
                sort: parsingResult.parsedValue?.customCalculations?.output?.sort
                    ?? parsingResult.parsedValue?.output?.sort
                    ?? []
            }
        };

        return coalesceResult;
    }

}
